import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { logOut } from '../../features/auth/authSlice'
import { warningSnack } from 'features/snack-bar/snackSlice'
import { UNAUTHORIZED_401_API_MESSAGES } from 'constants'

export const authQuery = fetchBaseQuery({
  baseUrl: '/api',
  credentials: 'include',

  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const authQueryWithReauth = async (args, api, extraoptions) => {
  let response = await authQuery(args, api, extraoptions)
  const error = response?.error || false
  if (error) {
  if (error.status === 401) {
    //set to error if token is expired
    const message = error?.data?.message || 'user_not_authenticated'
    if (message === UNAUTHORIZED_401_API_MESSAGES.not_authenticated) {
      api.dispatch(
        warningSnack({
          message: 'Su sesión ha expirado, por favor inicie sesión nuevamente',
        })
      )
      api.dispatch(logOut())
    }
  }}
  return response
}

export const apiSlice = createApi({
  baseQuery: authQueryWithReauth,
  endpoints: (builder) => ({}),
})
